import { render, staticRenderFns } from "./GetSupportDialog.vue?vue&type=template&id=20a5689a&scoped=true"
import script from "./GetSupportDialog.vue?vue&type=script&lang=ts"
export * from "./GetSupportDialog.vue?vue&type=script&lang=ts"
import style0 from "./GetSupportDialog.vue?vue&type=style&index=0&id=20a5689a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5689a",
  null
  
)

export default component.exports